"use client";
import { useCallback, useEffect, useState } from "react";
import { parseGuestCart, type GuestCart } from "./cart.js";

const KEY = "briolin.guestCart";

export function useGuestCart() {
  const [cart, setCart] = useState<GuestCart>({ items: [] });
  useEffect(() => { try { setCart(parseGuestCart(localStorage.getItem(KEY))); } catch { setCart({ items: [] }); } }, []);
  const persist = useCallback((next: GuestCart) => { setCart(next); localStorage.setItem(KEY, JSON.stringify(next)); }, []);
  const add = useCallback((productId: string, qty = 1) => {
    setCart((prev) => {
      const items = [...prev.items];
      const i = items.findIndex((x) => x.productId === productId);
      if (i >= 0) items[i] = { ...items[i], qty: items[i].qty + qty }; else items.push({ productId, qty });
      const next = { items };
      localStorage.setItem(KEY, JSON.stringify(next));
      return next;
    });
  }, []);
  const clear = useCallback(() => persist({ items: [] }), [persist]);
  return { cart, add, clear };
}
